/* eslint-disable */
import React, { Component, useState, useEffect, useRef } from 'react'
import SideBar from './SideBar'
import styled, { keyframes } from 'styled-components'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useLocation } from 'react-router-dom'
import ReactToPrint from 'react-to-print'
import { bounce } from 'react-animation'
import apiInstance from '../../utils/api'
import calculateAge from '../../features/autoIncreaseAge'

const Top = styled.div`
  display: flex;
  justify-content: space-between;
 
`

const TR = styled.tr`
  border-style: hidden;
`

const Left = styled.div`
  font-weight: bold;
  flex: 1;
`

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`

const Div = styled.div``

const Table = styled.table``
const Thead = styled.thead``
const Tbody = styled.tbody``
const Tr = styled.tr`
  text-align: center;
  
`
const Th = styled.th`
  font-size: 40px;
`

const Thi = styled.th`
  font-size: 40px;
  width: 2px;
`

const Td = styled.td`
  font-size: 80px;
  margin-top: 20px;
`
const Tdi = styled.td`
  font-size: 40px;
  margin-top: 20px;
  width: 2px;
`

const Hr = styled.hr`
  border-style: solid;
  width: 50%;
`
const H6 = styled.h6`
  font-size: 40px;
  margin-top: 25px;
`

const TestVoucherSlip = () => {
  const [vouchers, setVouchers] = useState([])
  const [total, setTotal] = useState('')
  const [discount, setDiscount] = useState('')
  const [net, setNet] = useState('')
  const [pay, setPay] = useState('')
  const [change, setChange] = useState('')
  const [code, setCode] = useState('')
  const [creditAmount, serCreditAmount] = useState('')
  const [phone, setPhone] = useState('')
  const [gender, setGender] = useState('')
  const [doctor, setDoctor] = useState('')
  const [labId, setLabId] = useState("")
  const [date, setDate] = useState('')
  const [name, setName] = useState('')
  const [age, setAge] = useState('')
  const [repayAmount, setRepayAmount] = useState('')
  const [remark, setRemark] = useState('')
  const [paid, setPaid] = useState('')
  const [bod, setBOD] = useState("")
  const today = new Date(Date.now()).toISOString()

  let componentRef = useRef()
  const vouid = useLocation().pathname.split('/')[2]

  useEffect(() => {
    const getVouchers = async () => {
      try {
        const res = await apiInstance.get(
          'voucher/' +
          vouid
        )
        setLabId(res.data.data?.labId)
        console.log(res.data.data)
        setGender(res.data.data.relatedPatient.gender)
        setPhone(res.data.data.relatedPatient.phone)
        setBOD(res.data.data.relatedPatient.dateOfBirth)
        setVouchers(res.data.data.testSelection)
        setTotal(res.data.data.totalCharge)
        setDiscount(res.data.data.discount)
        setNet(res.data.data.netDiscount)
        setPay(res.data.data.pay)
        setChange(res.data.data.change)
        setCode(res.data.data.code)
        setDate(res.data.data.date)
        setName(res.data.data.relatedPatient.name)
        setAge(res.data.data.relatedPatient.age)
        serCreditAmount(res.data.data.creditAmount)
        setDoctor(res.data.data.referDoctor.name)
        setRepayAmount(res.data.data?.repayAmount)
        setRemark(res.data.data?.creditRemark)
        setPaid(res.data.data?.isPaid)

      } catch (error) {
        // Swal.fire({
        //   title: 'Data not found for this day',
        //   text: 'Something Wrong',
        //   icon: 'warning',
        //   confirmButtonText: 'CANCEL'
        // })
        console.log('refresh')
      }
    }
    getVouchers()
  }, [])
  const print = () => {
    let printContents = document.getElementById('print').innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    // let printContents = document.getElementById('print').innerHTML;
    // let originalContents = document.body.innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents; 
  }
  return (
    <div className='wrapper'>
      <SideBar />
      {/* <!-- Content Wrapper. Contains page content --> */}

      <div className='content-wrapper'>
        {/* <!-- Content Header (Page header) --> */}
        <div className='content-header'>
          <div className='container-sm'>

            <div className='row'>
              <div className='col-12'>
                <Div
                  className='card'
                  style={{ padding: '' }}
                  ref={el => (componentRef = el)}
                >
                  <Div className='card-body' id='print'>
                    <h5 style={{ textAlign: 'center', fontSize: '60px', fontWeight: 900 }}>
                      WIN - Specialist Clinic & Diagnostic Center
                    </h5>
                    <h6
                      style={{
                        textAlign: 'center',
                        fontSize: '50px',
                        marginTop: '15px',
                        fontWeight: 900
                      }}
                    >
                      No (15/16), Marlarmyaing 2nd street, 16th Quarter, Hlaing township , Yangon.
                    </h6>
                    <div className='text-center'>
                      <span style={{ fontSize: '50px', marginTop: '15px', fontWeight: 900 }}>
                        Clinic- 09785069884, Laboratory - 09885069884
                      </span>
                    </div>

                    <br></br>
                    <div className='row'>
                      <div className='col-4'>
                        <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                          Lab ID :
                          <span className='float-right'>

                            {labId}
                          </span>
                        </div>
                      </div>
                      <div className='col-8 text-right'>
                        <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                          Voucher Date :
                          <span className='float-right ml-5'>
                            {date ? date.split('T')[0] : ''}
                          </span>
                        </div>
                      </div>

                    </div>
                    <div className='row'>
                      <div className='col-8'>
                        <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                          <span className='text-left'>   Doctor :</span>

                          <span className='ml-5'>
                            {doctor ? doctor : '-'}
                          </span>
                        </div>
                      </div>
                      <div className='col-4 text-right'>
                        <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                          Printed :
                          <span className='float-right'>
                            {today.split('T')[0]}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='col-5'>

                    </div>

                    <div className='col-7 text-right'>



                    </div>
                    <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                      <span className='text-left'>Customer :</span>
                      <span className='ml-5'>

                        {name ? name + "(" + gender + ")" + "/" + (calculateAge(bod) || age) : ''}
                      </span>
                    </div>
                    <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                      <span className='text-left'>C/Phone :</span>
                      <span className='ml-5'>
                       {phone ? phone : ''}
                      </span>
                    </div>
                    <div style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>
                      Inv. No :
                      <span className='ml-5'>
                        {code ? code : ''}
                      </span>
                    </div>


                    <br></br>


                    <table className='table'>
                      <thead className='slip'>
                        <Tr >
                          <td style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900 }}>#</td>
                          <td style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900, marginLeft: '10px', textAlign: 'left' }}
                          >
                            Name
                          </td>
                          <td style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900, marginLeft: '10px', textAlign: 'left' }}
                          >
                            Qty
                          </td>
                          <td style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900, marginLeft: '10px', textAlign: 'right' }}
                          >
                            Price
                          </td>
                          <td style={{ fontSize: '40px', marginTop: '15px', fontWeight: 900, marginLeft: '10px', textAlign: 'right' }}
                          >
                            Amt
                          </td>
                        </Tr>
                      </thead>
                      <Hr></Hr>
                      <tbody>
                        {vouchers.map((vou, index) => (
                          <Tr key={vou._id}>
                            <td style={{ fontSize: '40px', marginTop: '15px', marginLeft: '10px', textAlign: 'left', fontWeight: 900 }}
                            > {++index}</td>
                            <td style={{ fontSize: '40px', marginTop: '15px', marginLeft: '10px', textAlign: 'left', fontWeight: 900 }}
                            >
                              {vou.name.name.includes('NS')
                                ? vou.name.name.replace('NS', '')
                                : vou.name.name}
                            </td>
                            <td style={{ fontSize: '40px', marginTop: '15px', marginLeft: '10px', textAlign: 'left', fontWeight: 900 }}

                            >
                              {vou.qty ? vou.qty : ''}
                            </td>
                            <td style={{ fontSize: '40px', marginTop: '15px', marginLeft: '10px', textAlign: 'right', fontWeight: 900 }}
                            >
                              {vou.unitCharge ? vou.unitCharge : ''}
                            </td>
                            <td style={{ fontSize: '40px', marginTop: '15px', marginLeft: '10px', textAlign: 'right', fontWeight: 900 }}
                            >
                              {vou.subCharge ? vou.subCharge : ''}
                            </td>
                          </Tr>
                        ))}
                      </tbody>
                      <Hr></Hr>

                      <tfoot>

                        <TR>

                          <Td colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900

                            }}
                          >
                            Total
                          </Td>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900
                            }}
                          >
                            {total ? total : ''}
                          </Td>
                        </TR>
                        <TR>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900

                            }}
                          >
                            Discount
                          </Td>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900
                            }}
                          >
                            {discount ? discount : 0}
                          </Td>
                        </TR>

                        <TR>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900
                            }}
                          >
                            Pay
                          </Td>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900
                            }}
                          >
                            {pay ? pay : '-'}
                          </Td>
                        </TR>
                        <tr>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900
                            }}
                          >
                            Credit Amount
                          </Td>
                          <Td
                            colSpan={4}
                            style={{
                              textAlign: 'right',
                              fontSize: '40px',
                              marginTop: '20px',
                              fontWeight: 900
                            }}
                          >

                            {(pay && net) ? pay - net : 0}
                          </Td>
                        </tr>
                        {/* {paid === true || creditAmount === 0 ? (
                          <>
                            <tr>
                              <Td
                                colSpan={4}
                                style={{
                                  textAlign: 'right',
                                  fontSize: '35px',
                                  marginTop: '20px',
                                  fontWeight: 'bold'
                                }}
                              >
                                Repay Amount
                              </Td>
                              <Td
                                colSpan={4}
                                style={{
                                  textAlign: 'right',
                                  fontSize: '35px',
                                  marginTop: '20px',
                                  fontWeight: 'bold'
                                }}
                              >
                                {repayAmount}
                              </Td>
                            </tr>
                            <tr>
                              <Td
                                colSpan={4}
                                style={{
                                  textAlign: 'right',
                                  fontSize: '35px',
                                  marginTop: '20px',
                                  fontWeight: 'bold'
                                }}
                              >
                                Remark
                              </Td>
                              <Td
                                colSpan={4}
                                style={{
                                  textAlign: 'right',
                                  fontSize: '35px',
                                  marginTop: '20px',
                                  fontWeight: 'bold'
                                }}
                              >
                                "{remark}"
                              </Td>
                            </tr>
                            <tr>
                              <Td
                                colSpan={4}
                                style={{
                                  textAlign: 'right',
                                  fontSize: '35px',
                                  marginTop: '20px',
                                  fontWeight: 'bold'
                                }}
                              >

                              </Td>
                              <Td
                                colSpan={4}
                                style={{
                                  textAlign: 'right',
                                  fontSize: '35px',
                                  marginTop: '20px',
                                  fontWeight: 'bold'
                                }}
                              >
                                <mark>Is Paid</mark>
                              </Td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <Td
                              colSpan={4}
                              style={{
                                textAlign: 'right',
                                fontSize: '35px',
                                marginTop: '20px',
                                fontWeight: 'bold'
                              }}
                            >

                            </Td>
                            <Td
                              colSpan={4}
                              style={{
                                textAlign: 'right',
                                fontSize: '35px',
                                marginTop: '20px',
                                fontWeight: 'bold'
                              }}
                            >
                              Is Not Paid
                            </Td>
                          </tr>
                        )}
*/}
                        <Hr></Hr>
                        <tr>
                          <td

                            colSpan={5}
                            style={{
                              textAlign: 'center',
                              fontSize: '35px',
                              marginTop: '20px',
                              fontWeight: 900

                            }}
                          >

                            အ‌ဖြေလာရွှေးလျှင် ငွေရှင်းပြေစာ
                            ယူဆောင်လာပေးပါရန်နှင့်

                            <br />

                            ၃လကျော်သည့် အ‌ဖြေများကို
                            ထုတ်ပေးနိုင်မည်မဟုတ်‌ကြောင်း
                            မေတ္တာရပ်ခံပန်ကြားအပ်ပါသည်

                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </Div>
                </Div>
                {/* <ReactToPrint
                  trigger={() => ( */}
                <div className='text-center '>
                  <button
                    className='btn btn-lg w-50 btn-primary'
                    style={{ marginLeft: '240px' }}
                    onClick={print}
                  >
                    Print
                  </button>
                </div>

                {/* )}
                  content={() => componentRef}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default TestVoucherSlip
